// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-1:8ec35779-7423-43e2-8a68-dd048976698e',
    'aws_cognito_region': 'us-east-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'deeplearnui-hosting-mobilehub-471635468',
    'aws_content_delivery_bucket_region': 'us-east-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd2ayn5qzv2cfs2.cloudfront.net',
    'aws_mobile_analytics_app_id': 'f1ed66355b2f4444b9de7534a6300581',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': 'ece4f5b9-05aa-4e28-90a3-bc69aad3a83a',
    'aws_project_name': 'deeplearn-ui-2018-07-09-00-52-55',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'deeplearnui-mobilehub-471635468',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'deeplearnui-userfiles-mobilehub-471635468',
    'aws_user_files_s3_bucket_region': 'us-east-1',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_KEwnCGfrN',
    'aws_user_pools_mfa_type': 'ON',
    'aws_user_pools_web_client_id': '4ip3s3mhdnsftv09po67a0nscp',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js